import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const NewButton = ({ newItemPath, t }) => {
	return <Link to={newItemPath} className='btn btn-success'>{t('Common_New')}</Link>;
};

export default withTranslation()(NewButton);